import { Injectable } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';
import { ErrorMessageResponse } from '@app/core/models/data-response';
import { ConsignmentAssignParams, ConsignmentFreightParams } from './consignment.service';

@Injectable({ providedIn: 'root' })
export class CargonizerService {
    constructor(private datatask: DataTaskService) {}

    public async validate(params: ConsignmentFreightParams): Promise<CargonizerValidation> {
        return (await this.datatask.Post(404, params))[0];
    }

    public async create(params: ConsignmentFreightParams): Promise<CargonizerCreateResponse> {
        return (await this.datatask.Post(348, params))[0];
    }

    public async printLabels(params: CargonizerPrintParams): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(2653, params))[0];
    }

    public async getPrinters(params: ConsignmentAssignParams): Promise<CargonizerPrinter[]> {
        const connection: CargonizerConnection | undefined = (await this.datatask.Post(419, params))[0];
        if (!connection) return [];
        const printers: CargonizerPrinter[] = await this.datatask.Post(428, {
            cargonizer_api_key: connection.post_key, cargonizer_sender_id: connection.post_sender,
        });
        return printers.map(printer => ({ ...printer, printer_name: `${printer.cargonizer_printer_name} (${printer.printer_name})` }));
    }
}

export interface CargonizerValidation { status: string; status_message: string; }
export interface CargonizerCreateResponse extends ErrorMessageResponse { consignment_keyno: string | number; }
export interface CargonizerPrintParams extends ConsignmentAssignParams { cargonizer_printer_id: string | number; }
export interface CargonizerPrinter { printer_id: string | number; printer_name: string; cargonizer_printer_name: string; }
interface CargonizerConnection { post_key: string; post_sender: string; }
